"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var get2ndType_1 = require("../../util/get2ndType");
var shared_1 = require("../../constants/platform/shared");
function isDingTalkLite() {
    var secondType = get2ndType_1.default();
    return secondType === shared_1.sendType.LITE;
}
exports.isDingTalkLite = isDingTalkLite;
